import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { ShoppingBag, Globe, Layers } from "lucide-react";

const stats = [
  { icon: ShoppingBag, value: 50, suffix: "+", label: "Shopping categories" },
  { icon: Globe, value: 14, suffix: "", label: "Priority markets", subtitle: "plus global coverage" },
  { icon: Layers, value: 80, suffix: "+", label: "Retailers & sources" },
];

function CountUp({ target, suffix }: { target: number; suffix: string }) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView) return;
    const duration = 1200;
    const steps = 30;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [inView, target]);

  return (
    <span ref={ref} className="text-sm font-display font-bold text-foreground">
      {count.toLocaleString()}{suffix}
    </span>
  );
}

export default function SocialProofStrip() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.3 }}
      className="flex items-center justify-center gap-6 sm:gap-10 py-6 sm:py-8"
    >
      {stats.map((s) => {
        const Icon = s.icon;
        return (
          <div key={s.label} className="flex flex-col items-center gap-0.5">
            <div className="flex items-center gap-1.5">
              <Icon className="w-3 h-3 text-muted-foreground/60" />
              <CountUp target={s.value} suffix={s.suffix} />
            </div>
            <span className="text-[9px] text-muted-foreground/70 font-body">{s.label}</span>
            {"subtitle" in s && s.subtitle && (
              <span className="text-[8px] text-muted-foreground/50 font-body">{s.subtitle}</span>
            )}
          </div>
        );
      })}
    </motion.div>
  );
}
